// src/docs/DocsDocumentEdits.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsDocumentEdits = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
        Requesting Project Updates
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        To ensure that your project’s verification details remain accurate and up-to-date, CrowdLaunch allows you to request edits or upload new versions of your documents. This process helps you correct errors, update outdated information, or provide additional evidence as needed.
      </Typography>

      {/* Reasons for Requesting Edits/Uploads */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Why Request Edits &amp; Uploads?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        You might need to request an update if:
        <br />• Your documents have expired or changed.
        <br />• There is an error in the submitted information.
        <br />• Additional supporting documents are required.
        <br />• Your organizational details have been updated.
      </Typography>

      {/* How to Request an Update */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How to Request an Update
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        To request a document edit or upload, follow these steps:
        <br />1. Navigate to manage on CrowdLaunch.
        <br />2. Select the project you wish to update.
        <br />3. Select the document or field you wish to update.
        <br />4. Click the “Edit” icon next to the corresponding detail.
        <br />5. Enter a comment explaining the reason for your update.
        <br />6. Attach the new document if applicable.
        <br />7. Submit your request for review.
      </Typography>

      {/* What Happens Next */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        What Happens Next?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        After submission, your update request will be marked as pending. Our verification team will review your request and the new documentation. Once approved, the updated details will be reflected in your profile. If there are any issues, you will receive feedback to help you correct them.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        Keeping your documents current is crucial for maintaining your project's credibility and trust with investors. Please ensure your uploads are clear, legible, and up-to-date to facilitate a smooth verification process.
      </Typography>
    </Container>
  );
};

export default DocsDocumentEdits;
